import React, { useState } from "react";
import { serverUrl } from "../../setup";
import useUserContext from "../../hooks/useUserContext";
import Hint from "../../components/Hint";

const GuessRiddle = ({ setQuiz }) => {
  const [q1, setQ1] = useState("");
  const { user } = useUserContext();
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (q1) {
      const data = { answer: `${q1}` };
      try {
        const response = await fetch(serverUrl + "/question/7", {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });
        const json = await response.json();
        if (json.Correct) {
          setQuiz("killer");
        } else {
          setError(true);
        }
      } catch (e) {
        console.log(e);
      }
    }
  };
  return (
    <div className="font-medium text-lg text-white">
      <form
        action=""
        className="text-left flex flex-col justify-start items-center"
        onSubmit={handleSubmit}
      >
        <h1 className="my-2 text-justify">
          The enigma doesn't stop there. A riddle, shrouded in mystery, demands
          your attention. Like a cryptic whisper from the shadows, the riddle
          challenges your intellect. Every correct answer brings you closer to
          the heart of the Zodiac's elusive truth.
        </h1>

        <em className="text-justify">
          I am the twins in the sky, a celestial pair,
        </em>

        <em className="text-justify">
          Opposite yet together, a cosmic affair.
        </em>

        <em className="text-justify">
          Mercury guides me, with wit and with grace,
        </em>

        <em className="text-justify">
          In May or June, you'll find my embrace.
        </em>

        <h1>What am I?</h1>

        <input
          type="text"
          className="w-full text-black/70 mt-2 placeholder:text-base rounded-lg mb-2 px-2 py-1"
          placeholder="Enter answer"
          name="1"
          value={q1}
          onChange={(e) => {
            setQ1(e.target.value);
          }}
        />
        {error && <p className="text-red-500 text-center">Incorrect answer</p>}
        <button
          type="submit"
          className="border-2 border-white p-2 m-2 rounded-lg w-[50%] "
        >
          Submit
        </button>
      </form>
      <Hint hintText={"Name of a zodiac sign"} />
    </div>
  );
};

export default GuessRiddle;
